import React from 'react';
import { motion } from 'framer-motion';
const metrics = [{
  value: '25+',
  label: 'Years Experience'
}, {
  value: '$2.4B',
  label: 'Portfolio Value'
}, {
  value: '150+',
  label: 'Programs Delivered'
}, {
  value: '500+',
  label: 'Team Members Led'
}];
export function KeyMetrics() {
  return <section className="py-14 mt-8 bg-corporate-gray border-y border-[#E0D8C8]" data-id="element-263">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-264">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12" data-id="element-265">
          {metrics.map((metric, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="text-center relative" data-id="element-266">
              {/* Divider for desktop except last item */}
              {index < metrics.length - 1 && <div className="hidden md:block absolute right-0 top-1/2 -translate-y-1/2 w-px h-12 bg-[#D4CBBC] translate-x-6" data-id="element-267" />}

              <h3 className="text-3xl md:text-4xl font-bold text-corporate-blue mb-2" data-id="element-268">
                {metric.value}
              </h3>
              <p className="text-xs font-medium text-[#7A7062] uppercase tracking-wider" data-id="element-269">
                {metric.label}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}